import $ from 'jquery';
import 'bootstrap';
import cssVars from 'css-vars-ponyfill';
import 'blueimp-file-upload';
import './plugins/v2a.fieldset-collections';
import './plugins/v2a.confirm-delete';
import './plugins/v2a.nav-toggle';
import './plugins/v2a.back-btn';
import './plugins/v2a-tiny-rte';
import ActiveToggle from './plugins/v2a.active-toggle';
import select2 from 'select2';
import FileUpload from './plugins/v2a.file-upload';
import '../scss/v2a.v2a-udb.scss';
import '../scss/v2a.v2a-udb.libs.scss';

// Setup jquery for global usage
window.$ = window.jQuery = window.jquery = $;

// Add css-vars-ponyfill for css-vars support in legacy browsers
cssVars({
    include: 'link[rel=stylesheet],style',
    exclude: '',
    fixNestedCalc: true,
    onlyLegacy: true,
    onlyVars: false,
    preserve: false,
    silent: false,
    updateDOM: true,
    variables: {}
});

// Hook up select2 to jQuery
select2($);

(() => {
    // Activate FileUpload
    let fus = document.querySelectorAll('[role="file-upload"]');
    for (let i = 0; i < fus.length; i++) {
        let fu = new FileUpload(fus[i]);
        fu.init();
    }

    // Activate Active Toggle
    let toggles = document.querySelectorAll('[data-remote]');
    for (let i = 0; i < toggles.length; i++) {
        let at = new ActiveToggle(toggles[i]);
        at.init();
    }

    // Select2 Select Boxes
    $.fn.select2.defaults.set("theme", "bootstrap4");
    let selectElements = document.querySelectorAll('select');
    for (let i = 0; i < selectElements.length; i++) {
        $(selectElements[i]).select2();
    }
})();
